<template>
  <div class="drawer">
    <div class="map-container">
      <div :class="['map-preview', { reveal: drawerEnterEnd }]">
        <keep-alive>
          <img v-show="drawerEnterEnd" src="/tour/img/map-scheme.png" />
        </keep-alive>
        <AFBImage
          v-if="drawerEnterEnd && itemHovered !== false"
          class="map-floorplan"
          :imageUrl="getImgUrl"
        />
      </div>
    </div>
    <ul class="drawer-list">
      <li
        @mouseenter="itemHovered = i"
        @mouseleave="itemHovered = false"
        @click="() => selectItem(i)"
        :key="`place${i}`"
        v-for="(place, i) in $store.state.popups"
      >
        <router-link
          :class="[{ selected: itemSelected === i }, 'drawer-item']"
          :to="`/point/${i}`"
          >{{ place.acf.location_config.title }}
          <img src="../assets/arrow-right.svg"
        /></router-link>
      </li>
    </ul>
    <div class="footer">
      <div class="cta">
        <a href="https://www.acfb.org/" target="_blank">Visit ACFB.ORG</a>
        <a target="_blank" href="https://www.acfb.org/donate">Donate Now</a>
      </div>
      <span class="disclaimer">
        © 2021 Atlanta Community Bank. Atlanta Community Food Bank is a
        501(c)(3) private nonprofit organization.
        <a target="_blank" href="https://www.acfb.org/privacy-policy/"
          >Privacy Policy</a
        >|<a href="https://www.acfb.org/terms-of-use/" target="_blank">Terms</a>
      </span>
    </div>
  </div>
</template>
<script>
import AFBImage from "@/components/AFBImage";
export default {
  name: "DrawerList",
  components: { AFBImage },
  props: {
    drawerEnterEnd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      itemHovered: false,
      itemSelected: null,
    };
  },
  computed: {
    getImgUrl() {
      if (this.itemHovered !== false) {
        return this.$store.state.popups[this.itemHovered].acf.location_config
          .drawer_scheme;
      }
      return ``;
    },
  },
  methods: {
    selectItem(i) {
      this.$store.commit("setSidebar", false);
      this.$store.commit("setSelectedItem", null);
      this.itemSelected = Number(i);
      this.$store.commit("setSidebar", true);
      this.$store.commit("setSelectedItem", i);
      this.$emit("changeRoom", i);
      this.$store.commit("setDrawer", false);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/_colors";
@import "../assets/styles/_variables";
@import "../assets/styles/_typography";
@import "../assets/styles/_breakpoints";
$footerHeight: 150px;
.selected {
  color: white;
  transition: all 0.3s ease;
  background: $orange;
}
.drawer {
  background: $backWhite;
  height: calc(100vh - #{$headerHeight});
  position: absolute;
  display: flex;
  flex-direction: row;
  right: 0;
  overflow: hidden;
  z-index: 1000;
  width: 100%;
  &-list {
    background: $backWhite;
    animation: revealItem 0.3s ease-in forwards 1s;
    opacity: 0;
    transform: translateY(-40px);
    width: 20%;
    margin-right: 30px;
    overflow-y: scroll;
    height: calc(100vh - #{$headerHeight + $footerHeight});
    display: flex;
    flex-direction: column;
    gap: 20px;
    list-style: none;
    padding: 0;
    @include media("<=tablet") {
      overflow-y: initial;
      display: flex;
      align-items: center;
      justify-content: center;
      height: auto;
      padding: 30px;
      margin-right: 0;
      box-sizing: border-box;
      width: 100%;
    }
  }
  li {
    max-width: 380px;
    a {
      text-decoration: none;
    }
    width: 100%;
  }
  &-item {
    display: flex;
    position: relative;
    will-change: color, background;
    transition: all 0.3s ease;
    align-items: center;
    color: $orange;
    box-sizing: border-box;
    width: 100%;
    overflow-wrap: normal;
    hyphens: none;
    padding: 8px 65px 8px 22px;
    //font
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.668571px;
    text-align: left;
    //
    border-radius: 25px;
    background: white;
    cursor: pointer;
    &:hover {
      color: white;
      background: $orange;
    }
    img {
      position: absolute;
      right: 13px;
      top: 20%;
      width: 20px;
    }
  }
  @include media("<=tablet") {
    flex-direction: column;
    align-items: center;
    height: 100%;
    overflow: auto;
  }
}
.map-container {
  width: 80%;
  @include media("<=tablet") {
    display: none;
  }
}
.map-floorplan {
  opacity: 0.5;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  z-index: 9;
  max-width: none;
  width: 100%;
  &::v-deep {
    img {
      object-fit: contain;
      height: 100%;
    }
  }
  @include media("<=tablet") {
    display: none;
  }
}
.map-preview {
  position: relative;
  img {
    max-width: 100%;
    object-fit: contain;
    height: calc(100vh - #{$headerHeight});
  }
  &::after {
    z-index: 10;
    content: "";
    will-change: opacity;
    background: $warmWhite;
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    opacity: 1;
  }
  @include media("<=tablet") {
    display: none;
  }
}
.reveal {
  &::after {
    transition: 0.5s ease-in opacity;
    opacity: 0;
  }
}
.footer {
  position: fixed;
  bottom: 0;
  z-index: 10;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 30px;
  box-sizing: border-box;
  .cta {
    display: flex;
    grid-gap: 12px;
    flex-direction: column;
    a {
      text-decoration: none;
      transition: all 0.5s ease;
      background: $orange;
      color: white;
      font-weight: 500;
      padding: 13px;
      border-radius: 8px;
      font-family: "omnes-pro", sans-serif;
      font-size: 16px;
      line-height: 21px;
      letter-spacing: 1.00286px;
      &:hover {
        background: white;
        color: $orange;
      }
      @include media("<=tablet") {
        padding: 10px;
      }
    }
  }
  .disclaimer {
    font-family: "Omnes M", sans-serif;
    font-size: 12px;
    line-height: 18px;
    align-self: flex-end;
    letter-spacing: 0.835714px;
    width: 40%;
    a {
      color: black;
      text-decoration: none;
    }
    @include media("<=tablet") {
      width: 100%;
      margin-top: 30px;
    }
  }
  @include media("<=tablet") {
    position: initial;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
@keyframes revealItem {
  from {
    transform: translateY(-40px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
